export const environment = {
  production: true,
  graphQL_URL:'https://api.stoltuat.com/pooling-portal-2/graphql',
  navType: 'uat',
  B2C_CLIENTID:'e97f112e-8301-4df0-9ab4-286590aa2548',
  AUTHORITY:'https://stoltuatb2c.b2clogin.com/stoltuatb2c.onmicrosoft.com/B2C_1A_POOLINGPORTAL2_SIGNUP_SIGNIN',
  KNOWNAUTHORITIES:['stoltuatb2c.b2clogin.com'],
  USERSCOPE:'https://stoltuatb2c.onmicrosoft.com/844f0b74-285f-4392-90e7-03478ca422bf/read',
  GRAPH_ENDPONT:'https://graph.microsoft.com/v1.0/me',
  REDIRECT_URI:'https://stpoolingportal2.stoltuat.com/distribution',
  POST_LOGOUT_REDIRECT_URI:'https://stpoolingportal2.stoltuat.com',
  googleAnalytic:'uat',
  googleAnalyticKey:'G-VLD0MB84G5', //'G-CQMHYLBYH4',
  googleTagManager:'GTM-MX3V34S7',
  //googleAnalyticUAKey:'UA-277407103-1',
  GET_IP_ADDRESS_API :"https://ipwhois.app/json/"
};